import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useLanguage } from "../store/language-context";

const useHomeSection = ({ sectionName }) => {
    const { URL } = useLanguage();
    const { data, error, isLoading } = useQuery({
        queryKey: ['home-section', sectionName, URL],
        queryFn: async () => {
            const response = await axios.get(`${URL}/home-pages?title_section=${sectionName}`);
            if (response.status === 200) {
                return response?.data?.data?.data || [];
            } else {
                throw new Error("عفوا , حدث خطأ ما!");
            }
        },
        staleTime: 15 * 60 * 1000, // 15 min
        cacheTime: 30 * 60 * 1000, // 30 min
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        retry: 1,
        keepPreviousData: true,
    });
    return { data, error, isLoading };
};

export default useHomeSection;